const productSlider = document.querySelector('#js-product-slider')

if (productSlider) {


  const productSliderSwiper = new Swiper(productSlider, {
      centerInsufficientSlides: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
  })

  productSliderSwiper.on('slideChange', (e) => {
    const index = e.activeIndex

    const activeButton = document.querySelector('.product-page__slider-button--active')
    activeButton.classList.remove('product-page__slider-button--active')

    const newActiveButton = document.querySelector(`.product-page__slider-button[data-slide="${index}"]`)
    newActiveButton.classList.add('product-page__slider-button--active')
  })



  const productSliderButtons = document.querySelectorAll('.product-page__slider-button')

  productSliderButtons.forEach((item) => {
    item.addEventListener('click', function() {
      const index = this.getAttribute('data-slide')
      productSliderSwiper.slideTo(index)
    })
  })


  const productImages = document.querySelectorAll('.product-page__image img')

  productImages.forEach((item) => {
    imageZoom(item)
  })


  function imageZoom(img) {
      const zoomCircle = img.parentElement.querySelector('.product-page__zoom-circle');

      const zoom = 2;

      img.addEventListener('mousemove', function(event) {
        // Calculate the image's position relative to the viewport
        const rect = img.getBoundingClientRect();

        
        // Get the x, y coordinates of the mouse pointer relative to the image
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        
        // Calculate the background position for the zoom circle
        const bgX = x - (zoomCircle.clientWidth / 2) / zoom;
        const bgY = y - (zoomCircle.clientHeight / 2) / zoom;
        // Position the zoom circle
        zoomCircle.style.left = `${x - zoomCircle.clientWidth / 2}px`;
        zoomCircle.style.top = `${y - zoomCircle.clientHeight / 2}px`;
    
        // Set the background image and position for the zoom circle
        zoomCircle.style.backgroundImage = `url(${img.src})`;
        zoomCircle.style.backgroundPosition = `-${bgX * zoom}px -${bgY * zoom}px`;
        zoomCircle.style.backgroundSize = `${img.clientWidth * zoom}px ${img.clientHeight * zoom}px`;
    
        // Show the zoom circle
        zoomCircle.classList.remove('product-page__zoom-circle--hidden');
      });
    
      // Hide the zoom circle when the mouse leaves the image
      img.addEventListener('mouseleave', function() {
        zoomCircle.classList.add('product-page__zoom-circle--hidden');
      });
  }
}
